import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'approvazioni',
  titolo: 'Approvazioni e funzioni sotto controllo',
  gruppo: 'Report e gestione',
  permesso: ['approvazione.decidi', 'flag.gestisci'],
  aCheServe: 'Alcuni atti chiedono il sì di una seconda persona: chi chiede non decide. Le richieste si decidono '
    + 'nella pagina «Approvazioni». Le funzioni che controllano il lavoro delle persone, come la webmail con '
    + 'l’archivio della posta, si accendono da «Amministrazione» → «Impostazioni», solo dopo l’approvazione. '
    + 'In CIDIS non c’è un DPO: le decisioni del DPO le prende la Referente privacy.',
  parti: [
    {
      titolo: 'Decidere una richiesta',
      permesso: 'approvazione.decidi',
      passi: [
        'Apri «Approvazioni». Ogni richiesta dice chi la chiede, la motivazione, su che cosa e chi decide.',
        'Premi «Approva», oppure «Respingi» e scrivi il «Motivo del rifiuto».',
        'Se servono più decisioni, la riga dice quante ne mancano e di chi. Per accendere una funzione sotto '
          + 'controllo decidono la Direzione e la Referente privacy, ognuna con la sua.',
      ],
      nota: 'Le richieste che hai fatto tu non le decidi: la riga lo dice. Dove la riga dice «il Referente privacy '
        + 'o il DPO» basta la decisione di uno dei due.',
    },
    {
      titolo: 'Decidere come Referente privacy',
      permesso: 'posta.supervisione_concedi',
      passi: [
        'In «Approvazioni» trovi anche le richieste che spettano a te al posto del DPO: blocco legale, accensione '
          + 'di una funzione sotto controllo, supervisione di una casella di posta, visione di una registrazione, '
          + 'accesso straordinario all’area riservata, cancellazione definitiva chiesta dalla Direzione, testo '
          + 'dell’avviso in calce alla posta.',
        'Per l’avviso in calce la riga mostra il «Testo proposto»; apri «Testo in vigore» per confrontarlo. Il testo '
          + 'nuovo vale da quando approvi.',
        'Premi «Approva», oppure «Respingi» con il motivo.',
      ],
      nota: 'Una richiesta che apri tu non la decidi. Se sei l’unica Referente e non c’è un DPO, le richieste che '
        + 'chiedono la tua decisione falle aprire a un’altra persona: la tua non si aprirebbe.',
    },
    {
      titolo: 'Accendere una funzione sotto controllo',
      permesso: 'flag.gestisci',
      passi: [
        'In «Amministrazione», linguetta «Impostazioni», trova il riquadro della funzione, per esempio «Webmail e '
          + 'archiviazione integrale della posta».',
        'Premi «Chiedi l’approvazione». Nella «Motivazione» scrivi gli estremi di ogni presupposto: data, '
          + 'protocollo, dove è archiviato. Premi «Invia la richiesta».',
        'Direzione e Referente privacy decidono in «Approvazioni». Il riquadro dice a che punto è la richiesta.',
        'Quando è approvata, spunta le voci di «Prerequisiti da verificare», ognuna solo se il documento è firmato '
          + 'e archiviato, e premi «Attiva».',
      ],
      nota: 'L’approvazione vale trenta giorni e una volta sola: se la funzione si spegne, per riaccenderla ne '
        + 'serve una nuova. Spegnere non chiede approvazione.',
    },
  ],
  avvertenze: [
    {
      quando: '«Attiva» resta grigio.',
      cosaFare: 'Servono l’approvazione concessa e la spunta di ogni prerequisito. Il riquadro dice se la richiesta '
        + 'è ancora in attesa e di chi.',
    },
    {
      quando: '«L’approvazione è scaduta: va chiesta di nuovo.»',
      cosaFare: 'Sono passati i trenta giorni. Premi «Chiedi di nuovo l’approvazione».',
    },
    {
      quando: '«Nessun incarico attivo porta la Direzione»',
      cosaFare: 'La richiesta non si può aprire finché qualcuno non ha l’incarico di Direzione. Chiedilo a chi '
        + 'gestisce gli utenti.',
    },
    {
      quando: 'Sei la Referente privacy (o il DPO) e il riquadro dice che la richiesta la decidi anche tu.',
      cosaFare: 'Falla chiedere a un’altra persona, di norma chi amministra il gestionale: chi chiede non decide. '
        + 'Se sei l’unica con quel ruolo, la richiesta non si apre se la chiedi tu.',
    },
    {
      quando: '«… chi la chiede è l’unica persona con quel ruolo: chi chiede non decide.»',
      cosaFare: 'La richiesta va aperta da un’altra persona: tu poi la decidi in «Approvazioni».',
    },
  ],
  vediAnche: ['posta', 'utenti'],
  parole: ['approvazione', 'approva', 'respingi', 'quattro occhi', 'interruttore', 'attiva', 'accendere',
    'impostazioni', 'prerequisiti', 'webmail', 'sorveglianza', 'referente privacy', 'dpo', 'avviso in calce'],
}

export default capitolo
